import axios, { AxiosResponse } from 'axios';

import defaultHeaders from './default-headers';

/**
 * Post request function
 * @param {any} url - The url
 * @param {any} data - The data
 * @param {any} isFileUpload - The isFileUpload
 */
const postRequest = async (
  url: string,
  data?: any,
  isFileUpload = false,
): Promise<AxiosResponse<any>> => {
  try {
    const customHeaders: Record<string, string> = isFileUpload
      ? { 'Content-Type': 'multipart/form-data' }
      : {};

    const authToken = defaultHeaders();
    const headers = {
      ...(authToken && authToken), // Add Authorization header if token exists
      ...customHeaders,
    };

    console.log('[postRequest] Sending POST request to:', url);
    console.log('[postRequest] Data:', data);
    console.log('[postRequest] Headers:', headers);

    return await axios.post(url, data, { headers });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default postRequest;
